module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-validate-date-format"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dtereq),
      expression: "dtereq"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    class: {
      'input-error': _vm.errors.has('dtereq')
    },
    attrs: {
      "type": "text",
      "maxlength": "10",
      "name": "dtereq",
      "data-vv-as": "dtereq",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.dtereq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dtereq = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtereq')),
      expression: "errors.has('dtereq')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtereq')))]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "data-vv-name": "dtework",
      "name": "dtework",
      "has-error": _vm.errors.has('dtework')
    },
    model: {
      value: (_vm.dtework),
      callback: function($$v) {
        _vm.dtework = $$v
      },
      expression: "dtework"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtework')),
      expression: "errors.has('dtework')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtework')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a46b183!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoValidateDateFormat.vue
// module id = 3739
// module chunks = 1